import React from 'react';
import Widget from 'components/Widget';
import './studentportal.less';
import studentPortalConfig from './moduleConfig';
import config from 'root/../config';
import Menu from './menu';
import PropTypes from 'prop-types';
import dataService from 'services/dataService';
import MsgBox from 'sis_ui/modules/notifications';
import AppContext from 'components/appContext';
import {withTranslation} from "react-i18next";
class Portal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            widgets: [],
            userRole: ""
        }

        this.widgetsReq = null;
    }

    componentDidMount() {
        if (this.context !== undefined)
            this.setState({userRole:this.context.userDetails.CURRENT_ROLE});
        this.getWidgets();
    }

    componentDidUpdate(){
        if(this.state.userRole !== this.context.userDetails.CURRENT_ROLE){
            this.setState({userRole:this.context.userDetails.CURRENT_ROLE})
            this.getWidgets()
        }
    }

    componentWillUnmount (){
        if(this.widgetsReq != null){
            this.widgetsReq.abort();
        }
    }

    getWidgets(){
        if(!this.props.isSideBar){
            this.widgetsReq = dataService.request({
                method: 'GET', 
                url: config.apiAppUrl + studentPortalConfig.APIs.getWidgets,
            }).accept('application/json');
                
            this.widgetsReq.then((res) => {
                try {
	            	if (res.statusCode == 200) {
						if (window.localStorage.getItem('redirected_to_policy') !== null) {
	            			window.localStorage.removeItem('redirected_to_policy');
	            			this.context.set('showCurrentPortalInfo', true);
	            		}
	                    let result = res.body;
	                    if (!result) {
	                        try {
	                            result = JSON.parse(res.text);
	                        } catch (e) {
	                            throw(e);
	                        }
	                    }

	                    let widgetsArray = result.map((widget)=> {
	                        return <Widget key={widget.id} id={widget.id} name={widget.name} title={widget.title} url={config.apiAppUrl + studentPortalConfig.APIs.getWidgets} />
	                    })

	                    this.setState({
	                        widgets: widgetsArray,
	                    })
					}
                } catch (e) {                    
                    MsgBox.drawMessage('error', this.props.t("lbl.INVALID_RESPONSE","Invalid response format"));
                }
            }, e => {
                console.error(e);
            });
        }
    }

    render() {
        return (
            <React.Fragment>
                {this.state.widgets.length ? 
                    <div className="studentPortal__widgets col mt-2">
                        {this.state.widgets}
                    </div>
                    :
                    null
                }

                <div className="studentPortal__modules flex-grow-1 justify-content-center align-items-center">
                    <Menu isSideBar={this.props.isSideBar}/>
                </div>
            </React.Fragment>
        )
    }
}

Portal.defaultProps = {
    isSideBar: false,
}

Portal.propTypes = {
    isSideBar: PropTypes.bool,
}

Portal.contextType = AppContext;

export default withTranslation()(Portal);